<app-users-list />

<button mat-fab matTooltip="Aggiungi nuovo utente" routerLink="/administration/users/add" class="addButton bg-primary">
    <mat-icon>add</mat-icon>
</button>